import React, { useEffect, useState } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import feedaLogo from '../../assets/feedaia-logo.svg';
import feedaLogoSm from '../../assets/logo-icon.svg';
import iconMenu from '../../assets/icon-menu-btn.svg';
import { AiOutlineStock } from 'react-icons/ai';
// import ProfilePic from '../../assets/user-img.jpg';
import { SlSettings } from 'react-icons/sl';
import { IoLogOutOutline } from 'react-icons/io5';
import { NavData } from '../Constant';
import { LuSearch } from 'react-icons/lu';
import { RiMenuFoldLine } from 'react-icons/ri';
import { IoArrowForwardOutline } from 'react-icons/io5';
import SessionsListSection from './SessionsListSection';
import { useContextHook } from 'use-context-hook';
import { AuthContext } from '../../Context/authContext';
import { StyledSideBar, ReponseMenu, MenuBtn, StyleItem } from './SideBar.styles';
import agentService from '../../services/agentService';
import { useQuery } from '@tanstack/react-query';

const SideBar = () => {
  const [sideBar, setSideBar] = useState(true);
  const [agentData, setAgentData] = useState([]);
  const [selectedAgent, setSelectedAgent] = useState({
    label: 'All',
    value: '',
  });

  const navigate = useNavigate();

  const handleSideBar = () => {
    setSideBar(!sideBar);
  };
  const { user, onLogout, refetch } = useContextHook(AuthContext, v => ({
    user: v.user,
    onLogout: v.onLogout,
    refetch: v.refetch,
  }));

  const getAllAgentData = useQuery({
    queryKey: ['get-all-agents'],
    queryFn: () => agentService.getAllAgent(),
    staleTime: Infinity,
    gcTime: Infinity,
  });
  useEffect(() => {
    if (getAllAgentData.isSuccess) {
      setAgentData([
        {
          agent_name: 'All',
          id: null,
        },
        {
          agent_name: 'Ferdy',
          id: '6d1cd244-2e8e-4782-981d-24cae676f7c7',
        },
        ...getAllAgentData?.data?.agents,
      ]);
    }
  }, [getAllAgentData.isSuccess]);

  useEffect(() => {
    if (sideBar) {
      document.body.classList.add('sidebar-active');
    } else {
      document.body.classList.remove('sidebar-active');
    }
  }, [sideBar]);

  // const toggleDropdown = id => {
  //   setChatDropdownOpen(prev => (prev === id ? null : id));
  // };

  return (
    <>
      <StyledSideBar $sideBar={sideBar}>
        <div className="nav-wrapper">
          <div className="nav-header">
            <div className="logo">
              <Link to="/dashboard">
                <img className="logo-lg" src={feedaLogo} width="148" alt="logo" />
                <img className="logo-sm" src={feedaLogoSm} width="25" alt="logo" />
              </Link>
            </div>
            <div className="icon-wrap">
              <div className="menu-btn" onClick={handleSideBar}>
                <img src={iconMenu} width="26" alt="icon" />
              </div>
              <div className="search-btn">
                <LuSearch size={28} />
              </div>
            </div>
          </div>
          <div className="scroll-area">
            <ul className="nav-links">
              {NavData?.map((elem, ind) => {
                return (
                  <li key={ind}>
                    <NavLink to={`/${elem.path}`}>
                      <img src={elem?.img} alt={elem.path} className="icon" />
                      <span className="label">{elem?.name}</span>
                    </NavLink>
                  </li>
                );
              })}
            </ul>
            <div className="chat-history">
              <div className="head">
                <span className="subheading">Chats</span>
                <ReponseMenu
                  menuButton={
                    <MenuBtn>
                      <span className="agent-name">{selectedAgent?.label}</span>
                    </MenuBtn>
                  }>
                  {agentData?.map((data, index) => (
                    <StyleItem
                      key={index}
                      onClick={() => {
                        setSelectedAgent({ label: data?.agent_name, value: data?.id });
                      }}>
                      <div className="text">{data?.agent_name}</div>
                    </StyleItem>
                  ))}
                </ReponseMenu>
              </div>
              <SessionsListSection selectedAgent={selectedAgent} />
            </div>

            <ul className="nav-links nav2">
              {/* <li>
              <NavLink to="/">
                <img className="icon" src={iconDownload} width={25} alt="icon" />
                <span className="label">Download</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/">
                <img className="icon" src={iconMore} width={25} alt="icon" />
                <span className="label">More</span>
              </NavLink>
            </li> */}
              <li>
                <NavLink to="/settings">
                  <SlSettings className="icon" />
                  <span className="label">Setting</span>
                </NavLink>
              </li>
              <li>
                <NavLink to="/analytics">
                  <AiOutlineStock className="icon" />
                  <span className="label">Analytics</span>
                </NavLink>
              </li>
              <li>
                <button className="btn-logout" onClick={onLogout}>
                  <IoLogOutOutline className="icon" />
                  <span className="label">Logout</span>
                </button>
              </li>
            </ul>
          </div>
        </div>
        <div className="profile-holder" onClick={() => navigate('/settings')}>
          <div className="profile-img">
            {/* <img src={user?.data?.profilePicture ? user?.data?.profilePicture : ProfilePic} alt="profilePic" /> */}
            <span className="text">{user?.first_name?.split('')[0]}</span>
          </div>
          <div className="profile-info">
            {/* <span className="name">{name}</span>
          <span className="email">{user?.data?.email}</span> */}

            <span className="name">{user?.first_name}</span>
            <span className="text">Free plan</span>
          </div>
          <IoArrowForwardOutline className="icon-arrow" />
        </div>
      </StyledSideBar>
    </>
  );
};

export default SideBar;
